import React from "react";
import Sideform from "../Sideform";
import { Link } from "react-router-dom";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";

const Veneers = () => {
  const serviceUrl = window.location.href;
  const faqData = [
    {
      question: "How long do veneers typically last?",
      answer:
        "Porcelain veneers last 10-15 years, while composite veneers last 5-7 years with proper care and regular dental check-ups.",
    },
    {
      question: "Are veneers a permanent solution?",
      answer:
        "Veneers are semi-permanent since some enamel is removed. While long-lasting, they may need replacement over time due to wear or damage.",
    },
    {
      question: "Can veneers fix crooked teeth?",
      answer:
        "Veneers can correct mild misalignment, but severe cases may require orthodontic treatments like braces or Invisalign for proper alignment.",
    },
    {
      question: "Do veneers stain over time?",
      answer:
        "Porcelain veneers are stain-resistant, but composite veneers may discolor.",
    },
  ];

  return (
    <>
      <title>
        Veneers Dubai â€“ Best Price for Porcelain &amp; Composite Veneers in
        Dubai
      </title>
      <meta
        name="description"
        content="Veneers Dubai: Enhance your smile with premium veneers in Dubai at Elite Body Home Polyclinic. Our custom-designed veneers correct discoloration, chips, gaps, and minor misalignment, offering a flawless, natural-looking smile."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/dental-veneers-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Veneers Dubai â€“ Best Price for Porcelain &amp; Composite Veneers in Dubai"
      />
      <meta
        property="og:description"
        content="Veneers Dubai: Enhance your smile with premium veneers in Dubai at Elite Body Home Polyclinic. Our custom-designed veneers correct discoloration, chips, gaps, and minor misalignment, offering a flawless, natural-looking smile."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/dental-veneers-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-22T15:42:08+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header.jpg"
      />
      <meta property="og:image:width" content="1080" />
      <meta property="og:image:height" content="708" />
      <meta property="og:image:alt" content="veneers dubai" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Veneers Dubai â€“ Best Price for Porcelain &amp; Composite Veneers in Dubai"
      />
      <meta
        name="twitter:description"
        content="Veneers Dubai: Enhance your smile with premium veneers in Dubai at Elite Body Home Polyclinic. Our custom-designed veneers correct discoloration, chips, gaps, and minor misalignment, offering a flawless, natural-looking smile."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header.jpg"
      />
      <div id="content" className="site-content heading-margin">
        <div className="ast-container">
          <div
            data-elementor-type="wp-post"
            data-elementor-id="3281"
            className="elementor elementor-3281"
            data-elementor-post-type="services"
          >
            <div
              className="elementor-element elementor-element-ae20d6e e-con-full e-flex e-con e-parent"
              data-id="ae20d6e"
              data-element_type="container"
              data-settings='{"background_background":"classNameic"}'
            >
              <div
                className="elementor-element elementor-element-52fbbf2 e-con-full e-flex e-con e-child"
                data-id="52fbbf2"
                data-element_type="container"
                data-settings='{"background_background":"classNameic"}'
              >
                <div
                  className="elementor-element elementor-element-a1a6cec e-con-full e-flex e-con e-child"
                  data-id="a1a6cec"
                  data-element_type="container"
                >
                  <div
                    className="elementor-element elementor-element-9d91486 elementor-widget elementor-widget-image"
                    data-id="9d91486"
                    data-element_type="widget"
                    data-widget_type="image.default"
                  >
                    <img
                      loading="lazy"
                      decoding="async"
                      width="1024"
                      height="671"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header-large.jpg"
                      className="attachment-large size-large wp-image-17073"
                      alt="veneers dubai"
                      srcset="
          https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header-large.jpg   1024w,
          https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header-medium.jpg   300w,
          https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header-768x503.jpg  768w,
          https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header-600x393.jpg  600w,
          https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Veneers-Header.jpg         1080w
        "
                      sizes="(max-width: 1024px) 100vw, 1024px"
                    />
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-bf70a67 e-con-full e-flex e-con e-child"
                  data-id="bf70a67"
                  data-element_type="container"
                >
                  <div
                    className="elementor-element elementor-element-bd8e304 elementor-widget elementor-widget-heading"
                    data-id="bd8e304"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h1 className="elementor-heading-title elementor-size-default">
                      Veneers Dubai
                    </h1>
                  </div>
                  <div
                    className="elementor-element elementor-element-5cd63ab elementor-widget elementor-widget-text-editor"
                    data-id="5cd63ab"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p style={{ textAlign: "center" }}>
                      Transform Your Smile with Perfect Veneers
                    </p>
                  </div>
                  <div
                    className="elementor-element elementor-element-d1f2c86 elementor-align-center elementor-widget elementor-widget-button"
                    data-id="d1f2c86"
                    data-element_type="widget"
                    data-widget_type="button.default"
                  >
                    <a
                      className="elementor-button elementor-button-link elementor-size-sm"
                      href="#consultation"
                    >
                      <span className="elementor-button-content-wrapper">
                        <span className="elementor-button-text">
                          <Link
                            className="elementor-button-text"
                            to={"/contact"}
                          >
                            Schedule Your Consultation Today
                          </Link>
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-c2126bd e-con-full e-flex e-con e-parent containerStyle"
              data-id="c2126bd"
              data-element_type="container"
              data-settings='{"background_background":"classNameic"}'
            >
              <div
                className="elementor-element elementor-element-cb4e1f9 e-con-full e-flex e-con e-child leftColumnStyle"
                data-id="cb4e1f9"
                data-element_type="container"
                data-settings='{"background_background":"classNameic"}'
              >
                <div
                  className="elementor-element elementor-element-71d1c0f elementor-widget elementor-widget-shortcode"
                  data-id="71d1c0f"
                  data-element_type="widget"
                  data-widget_type="shortcode.default"
                >
                  <div className="elementor-shortcode">
                    <div className="breadcrumbs">
                      <a href="https://elitebodyhome.com">Home</a> &raquo;
                      <a href="https://elitebodyhome.com/">Services</a>
                      &raquo; Veneers Dubai
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-c7efbf2 elementor-icon-list--layout-inline elementor-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                  data-id="c7efbf2"
                  data-element_type="widget"
                  id="Procedure"
                  data-widget_type="icon-list.default"
                >
                  <ul className="elementor-icon-list-items elementor-inline-items">
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#Introduction">
                        <span className="elementor-icon-list-text">
                          Introduction
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#what">
                        <span className="elementor-icon-list-text">
                          What are Veneers
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#veneerstypes">
                        <span className="elementor-icon-list-text">
                          Veneers Types
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#benefits">
                        <span className="elementor-icon-list-text">
                          Benefits
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#procedure">
                        <span className="elementor-icon-list-text">
                          Procedure
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#price">
                        <span className="elementor-icon-list-text">Price</span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#eligibility">
                        <span className="elementor-icon-list-text">
                          Eligibility
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#results">
                        <span className="elementor-icon-list-text">
                          Results
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#reviews">
                        <span className="elementor-icon-list-text">
                          Reviews
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#myths">
                        <span className="elementor-icon-list-text">
                          Myths vs. Facts
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#whychoose">
                        <span className="elementor-icon-list-text">
                          Why Choose Us
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#ourteam">
                        <span className="elementor-icon-list-text">
                          Our Team
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#otherservices">
                        <span className="elementor-icon-list-text">
                          Other Services
                        </span>
                      </a>
                    </li>
                    <li className="elementor-icon-list-item elementor-inline-item">
                      <a href="#faq">
                        <span className="elementor-icon-list-text">FAQ</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div
                  className="elementor-element elementor-element-4faf637 e-con-full e-flex e-con e-child"
                  data-id="4faf637"
                  data-element_type="container"
                >
                  <div
                    className="elementor-element elementor-element-69bcec7 elementor-widget elementor-widget-heading"
                    data-id="69bcec7"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Dental Veneers in Dubai
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-f1115c7 elementor-widget elementor-widget-text-editor"
                    data-id="f1115c7"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p>
                      Transform your smile with veneers in Dubai at Elite Body
                      Home Polyclinic, the leading clinic for smile makeovers.
                      Whether addressing chips, gaps, or discoloration, our
                      custom-crafted solutions provide natural, long-lasting
                      results.
                    </p>
                    <p>
                      From composite veneers to porcelain, we ensure a precise
                      fit tailored to your unique smile. Boost your confidence
                      with a flawless, radiant look!
                    </p>
                    <h3>Quick Facts About Veneers</h3>
                    <ul>
                      <li>
                        <strong>Treatment Type:</strong> Cosmetic dental
                        procedure
                      </li>
                      <li>
                        <strong>Materials:</strong> Porcelain or composite resin
                      </li>
                      <li>
                        <strong>Price:</strong> Ranges from
                        <strong>3,999 to 25,000 AED</strong> (varies based on
                        the number of teeth)
                      </li>
                      <li>
                        <strong>Purpose:</strong> Corrects chips, gaps,
                        discoloration, and minor misalignment
                      </li>
                      <li>
                        <strong>Durability:</strong> <strong>Porcelain</strong>{" "}
                        lasts 10-15 years; <strong>composite</strong> lasts 5-7
                        years
                      </li>
                      <li>
                        <strong>Procedure Time:</strong> 2-3 visits for
                        porcelain; same-day for composite
                      </li>
                      <li>
                        <strong>Pain Level:</strong> Minimal discomfort, local
                        anesthesia may be used
                      </li>
                      <li>
                        <strong>Maintenance:</strong> Regular brushing,
                        flossing, and dental check-ups
                      </li>
                      <li>
                        <strong>Staining:</strong> Porcelain is stain-resistant;
                        composite may discolor over time
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-611e660 elementor-align-center elementor-widget elementor-widget-button"
                  data-id="611e660"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <a
                    className="elementor-button elementor-button-link elementor-size-sm"
                    href="#consultation"
                  >
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Call Now</span>
                    </span>
                  </a>
                </div>
                <div
                  className="elementor-element elementor-element-96d5487 e-con-full e-flex e-con e-child"
                  data-id="96d5487"
                  data-element_type="container"
                  id="what"
                >
                  <div
                    className="elementor-element elementor-element-162697a elementor-widget elementor-widget-heading"
                    data-id="162697a"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      What Are Veneers?
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-1975a53 e-con-full e-flex e-con e-child"
                    data-id="1975a53"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-6e0e4ec e-con-full e-flex e-con e-child"
                      data-id="6e0e4ec"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-f8eb0d1 elementor-widget elementor-widget-image"
                        data-id="f8eb0d1"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="1024"
                          height="1024"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-large.jpg"
                          className="attachment-large size-large wp-image-10551"
                          alt="best veneers in dubai"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-large.jpg   1024w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-300x300.jpg  300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-small.jpg    150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-768x768.jpg  768w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-600x600.jpg  600w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre-100x100.jpg  100w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Pagdgdre.jpg         1080w
                    "
                          sizes="(max-width: 1024px) 100vw, 1024px"
                        />
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-752febc e-con-full e-flex e-con e-child"
                      data-id="752febc"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-d8beeaa elementor-widget elementor-widget-text-editor"
                        data-id="d8beeaa"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <p>
                          Veneers are thin, custom-made shells designed to cover
                          the front surface of teeth, enhancing their
                          appearance. Made from{" "}
                          <strong>porcelain or composite</strong> resin, they
                          help correct discoloration, chips, gaps, and minor
                          misalignment.
                        </p>
                        <p>
                          Veneers provide a natural-looking, long-lasting
                          solution for a flawless smile with minimal tooth
                          alteration. They are a popular cosmetic treatment for
                          achieving whiter, straighter, and more symmetrical
                          teeth.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-575fc8f e-con-full e-flex e-con e-child"
                  data-id="575fc8f"
                  data-element_type="container"
                  id="veneerstypes"
                >
                  <div
                    className="elementor-element elementor-element-9bd4f1f elementor-widget elementor-widget-heading"
                    data-id="9bd4f1f"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Types of Veneers We Offer
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-e96d9d8 e-con-full e-flex e-con e-child"
                    data-id="e96d9d8"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-b99cc71 e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="b99cc71"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    >
                      <div
                        className="elementor-element elementor-element-f6ea17b elementor-widget elementor-widget-image"
                        data-id="f6ea17b"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="400"
                          height="400"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/9-large.jpg"
                          className="attachment-large size-large wp-image-10230"
                          alt="Porcelain Veneers"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/9.jpg         400w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/9-300x300.jpg 300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/9-small.jpg   150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/9-100x100.jpg 100w
                    "
                          sizes="(max-width: 400px) 100vw, 400px"
                        />
                      </div>
                      <div
                        className="elementor-element elementor-element-5b2a787 elementor-widget elementor-widget-icon-box"
                        data-id="5b2a787"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-icon-box-wrapper">
                          <div className="elementor-icon-box-content">
                            <h3 className="elementor-icon-box-title">
                              <span> Porcelain Veneers </span>
                            </h3>

                            <p className="elementor-icon-box-description">
                              Durable, stain-resistant, and natural-looking,
                              ideal for long-lasting smile enhancement.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-0b8beb3 e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="0b8beb3"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    >
                      <div
                        className="elementor-element elementor-element-a668bb0 elementor-widget elementor-widget-image"
                        data-id="a668bb0"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="400"
                          height="400"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/7-large.jpg"
                          className="attachment-large size-large wp-image-10227"
                          alt="Composite Veneers"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/7.jpg         400w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/7-300x300.jpg 300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/7-small.jpg   150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/7-100x100.jpg 100w
                    "
                          sizes="(max-width: 400px) 100vw, 400px"
                        />
                      </div>
                      <div
                        className="elementor-element elementor-element-337660c elementor-widget elementor-widget-icon-box"
                        data-id="337660c"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-icon-box-wrapper">
                          <div className="elementor-icon-box-content">
                            <h3 className="elementor-icon-box-title">
                              <span> Composite Veneers </span>
                            </h3>

                            <p className="elementor-icon-box-description">
                              A cost-effective option that provides instant
                              results with minimal tooth preparation.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-85040f7 e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="85040f7"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    >
                      <div
                        className="elementor-element elementor-element-4881e2b elementor-widget elementor-widget-image"
                        data-id="4881e2b"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="400"
                          height="400"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5-large.jpg"
                          className="attachment-large size-large wp-image-10219"
                          alt="Ceramic Veneers"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5.jpg         400w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5-300x300.jpg 300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5-small.jpg   150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5-100x100.jpg 100w
                    "
                          sizes="(max-width: 400px) 100vw, 400px"
                        />
                      </div>
                      <div
                        className="elementor-element elementor-element-035f1f6 elementor-widget__width-initial elementor-widget elementor-widget-icon-box"
                        data-id="035f1f6"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-icon-box-wrapper">
                          <div className="elementor-icon-box-content">
                            <h3 className="elementor-icon-box-title">
                              <span> Ceramic Veneers </span>
                            </h3>

                            <p className="elementor-icon-box-description">
                              Strong and aesthetically pleasing, offering a
                              balance between durability and a natural finish.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-ecbab60 e-con-full e-flex e-con e-child"
                    data-id="ecbab60"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-308b3af e-con-full elementor-hidden-mobile e-flex elementor-invisible e-con e-child"
                      data-id="308b3af"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    ></div>
                    <div
                      className="elementor-element elementor-element-4dff324 e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="4dff324"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    >
                      <div
                        className="elementor-element elementor-element-54cd33c elementor-widget elementor-widget-image"
                        data-id="54cd33c"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="400"
                          height="400"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2-large.jpg"
                          className="attachment-large size-large wp-image-10216"
                          alt="E-Max Veneers"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2.jpg         400w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2-300x300.jpg 300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2-small.jpg   150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2-100x100.jpg 100w
                    "
                          sizes="(max-width: 400px) 100vw, 400px"
                        />
                      </div>
                      <div
                        className="elementor-element elementor-element-ade8ba8 elementor-widget elementor-widget-icon-box"
                        data-id="ade8ba8"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-icon-box-wrapper">
                          <div className="elementor-icon-box-content">
                            <h3 className="elementor-icon-box-title">
                              <span> E-Max Veneers </span>
                            </h3>

                            <p className="elementor-icon-box-description">
                              High-quality lithium disilicate veneers known for
                              superior strength, translucency, and a lifelike
                              appearance.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-bae924b e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="bae924b"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    >
                      <div
                        className="elementor-element elementor-element-2feed0a elementor-widget elementor-widget-image"
                        data-id="2feed0a"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="400"
                          height="400"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4-large.jpg"
                          className="attachment-large size-large wp-image-10218"
                          alt=""
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4.jpg         400w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4-300x300.jpg 300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4-small.jpg   150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4-100x100.jpg 100w
                    "
                          sizes="(max-width: 400px) 100vw, 400px"
                        />
                      </div>
                      <div
                        className="elementor-element elementor-element-58e98c9 elementor-widget__width-initial elementor-widget elementor-widget-icon-box"
                        data-id="58e98c9"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                      >
                        <div className="elementor-icon-box-wrapper">
                          <div className="elementor-icon-box-content">
                            <h3 className="elementor-icon-box-title">
                              <span> Zirconia Veneers </span>
                            </h3>

                            <p className="elementor-icon-box-description">
                              Ultra-durable and resistant to chipping, perfect
                              for those needing extra strength and longevity.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-7abdd17 e-con-full e-flex elementor-invisible e-con e-child"
                      data-id="7abdd17"
                      data-element_type="container"
                      data-settings='{"animation":"zoomIn"}'
                    ></div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-10c4455 e-con-full e-flex e-con e-child"
                  data-id="10c4455"
                  data-element_type="container"
                  id="benefits"
                >
                  <div
                    className="elementor-element elementor-element-4526b98 elementor-widget elementor-widget-heading"
                    data-id="4526b98"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Benefits of Dental Veneers in Dubai
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-53f0dc0 e-con-full e-flex e-con e-child"
                    data-id="53f0dc0"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-8bb5df3 e-con-full e-flex e-con e-child"
                      data-id="8bb5df3"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-9c10228 elementor-widget elementor-widget-image"
                        data-id="9c10228"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="1024"
                          height="1024"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-large.jpg"
                          className="attachment-large size-large wp-image-10557"
                          alt="dubai veneers"
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-large.jpg   1024w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-300x300.jpg  300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-small.jpg    150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-768x768.jpg  768w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-600x600.jpg  600w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage-100x100.jpg  100w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-sfsdfsfPage.jpg         1080w
                    "
                          sizes="(max-width: 1024px) 100vw, 1024px"
                        />
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-d11e9f8 e-con-full e-flex e-con e-child"
                      data-id="d11e9f8"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-8e0fc18 elementor-widget elementor-widget-text-editor"
                        data-id="8e0fc18"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <ul>
                          <li>
                            <strong>Instant Smile Enhancement:</strong> Fixes
                            discoloration, chips, gaps, and minor misalignment.
                          </li>
                          <li>
                            <strong>Natural Appearance:</strong> Blends
                            seamlessly with your teeth.
                          </li>
                          <li>
                            <strong>Long-Lasting:</strong> Porcelain lasts 10-15
                            years, composite 5-7 years.
                          </li>
                          <li>
                            <strong>Stain-Resistant:</strong> Porcelain veneers
                            resist discoloration.
                          </li>
                          <li>
                            <strong>Minimally Invasive: </strong> Preserves most
                            of your natural tooth structure.
                          </li>
                          <li>
                            <strong>Quick Results:</strong> Complete
                            transformation in 1-3 visits.
                          </li>
                          <li>
                            <strong>Boosts Confidence:</strong> A flawless smile
                            for a lasting impression.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-3808413 e-con-full e-flex e-con e-child"
                    data-id="3808413"
                    data-element_type="container"
                    id="procedure"
                  >
                    <div
                      className="elementor-element elementor-element-a3f24e0 elementor-widget elementor-widget-heading"
                      data-id="a3f24e0"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <h2 className="elementor-heading-title elementor-size-default">
                        Procedure for Getting Veneers in Dubai
                      </h2>
                    </div>
                    <div
                      className="elementor-element elementor-element-3c2d9ca elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="3c2d9ca"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Consultation and Assessment"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Consultation and Assessment </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            Discuss your smile goals and veneer options with our
                            cosmetic dentist.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-81a9cce elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="81a9cce"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Teeth Preparation"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Teeth Preparation </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            A thin layer of enamel is removed to ensure a
                            perfect fit, followed by impressions for custom
                            veneers.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-6420d3b elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="6420d3b"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Temporary Veneers (If Needed)"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Temporary Veneers (If Needed) </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            While your permanent veneers are being crafted,
                            temporary ones may be placed for protection.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-5435196 elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="5435196"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Custom Veneer Fabrication"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Custom Veneer Fabrication </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            High-quality porcelain, composite, ceramic, E-Max,
                            or zirconia veneers are created in a dental lab
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-c0e8abe elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="c0e8abe"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Final Fitting &amp; Bonding"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Final Fitting & Bonding </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            Once ready, the veneers are checked for fit and
                            shade before being permanently bonded to your teeth.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-2a3bd77 elementor-view-framed elementor-position-left elementor-vertical-align-middle elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="2a3bd77"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <a
                            href="#"
                            className="elementor-icon"
                            tabindex="-1"
                            aria-label="Aftercare &amp; Follow-up"
                          >
                            <svg
                              aria-hidden="true"
                              className="e-font-icon-svg e-far-star"
                              viewBox="0 0 576 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"></path>
                            </svg>
                          </a>
                        </div>

                        <div className="elementor-icon-box-content">
                          <h3 className="elementor-icon-box-title">
                            <a href="#"> Aftercare & Follow-up </a>
                          </h3>

                          <p className="elementor-icon-box-description">
                            Regular dental check-ups and proper oral hygiene
                            ensure long-lasting results.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-3cc3c52 e-con-full e-flex e-con e-child"
                  data-id="3cc3c52"
                  data-element_type="container"
                  id="price"
                >
                  <div
                    className="elementor-element elementor-element-b7b9328 elementor-widget elementor-widget-heading"
                    data-id="b7b9328"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Teeth Veneers Cost in Dubai
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-cc28061 elementor-widget elementor-widget-text-editor"
                    data-id="cc28061"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p>
                      Veneers Dubai price ranges from
                      <strong>3,999 to 25,000 AED</strong>, depending on the
                      type, number of teeth treated, and procedure complexity.
                      Porcelain, composite, ceramic, E-Max, and zirconia veneers
                      each offer unique benefits that affect the final cost.
                    </p>
                    <p>
                      At Elite Body Home Polyclinic, we provide free
                      consultations to help you choose the best veneer option
                      for your smile transformation.{" "}
                      <strong>Book your appointment today!</strong>
                    </p>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-72b4ad1 elementor-align-center elementor-widget elementor-widget-button"
                  data-id="72b4ad1"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <a
                    className="elementor-button elementor-button-link elementor-size-sm"
                    href="#consultation"
                  >
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Call Now</span>
                    </span>
                  </a>
                </div>
                <div
                  className="elementor-element elementor-element-70a8f18 e-con-full e-flex e-con e-child"
                  data-id="70a8f18"
                  data-element_type="container"
                  id="eligibility"
                >
                  <div
                    className="elementor-element elementor-element-2f7ac9c elementor-widget elementor-widget-heading"
                    data-id="2f7ac9c"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Ideal Candidates for Veneers
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-eb5cff6 elementor-widget elementor-widget-text-editor"
                    data-id="eb5cff6"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <ul>
                      <li>
                        <strong>Healthy Gums and Teeth</strong>: Free of decay
                        or disease.
                      </li>
                      <li>
                        <strong>Sufficient Enamel:</strong> Enough enamel for
                        veneer bonding.
                      </li>
                      <li>
                        <strong>Mild to Moderate Imperfections:</strong> Ideal
                        for minor cosmetic issues.
                      </li>
                      <li>
                        <strong>No Teeth Grinding:</strong> Bruxism sufferers
                        may need a mouthguard.
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-4b97ae7 e-con-full e-flex e-con e-child"
                  data-id="4b97ae7"
                  data-element_type="container"
                  id="results"
                >
                  <div
                    className="elementor-element elementor-element-ac164e5 elementor-widget elementor-widget-heading"
                    data-id="ac164e5"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Before &amp; After Results
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-b8e788a elementor-arrows-position-inside elementor-widget elementor-widget-image-carousel"
                    data-id="b8e788a"
                    data-element_type="widget"
                    data-settings='{"slides_to_show":"3","navigation":"arrows","slides_to_scroll":"1","image_spacing_custom":{"unit":"px","size":10,"sizes":[]},"autoplay":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","autoplay_speed":5000,"infinite":"yes","speed":500,"image_spacing_custom_tablet":{"unit":"px","size":"","sizes":[]},"image_spacing_custom_mobile":{"unit":"px","size":"","sizes":[]}}'
                    data-widget_type="image-carousel.default"
                  >
                    <div
                      className="elementor-image-carousel-wrapper swiper"
                      role="region"
                      aria-roledescription="carousel"
                      aria-label="Image Carousel"
                      dir="ltr"
                    >
                      <div
                        className="elementor-image-carousel swiper-wrapper"
                        aria-live="off"
                      >
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                          aria-label="1 of 3"
                        >
                          <figure className="swiper-slide-inner">
                            <img
                              decoding="async"
                              className="swiper-slide-image"
                              src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sdfsdgs-1.jpg"
                              alt="Dental Veneers"
                            />
                          </figure>
                        </div>
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                          aria-label="2 of 3"
                        >
                          <figure className="swiper-slide-inner">
                            <img
                              decoding="async"
                              className="swiper-slide-image"
                              src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sdfsdgs-2.jpg"
                              alt="dental implants"
                            />
                          </figure>
                        </div>
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                          aria-label="3 of 3"
                        >
                          <figure className="swiper-slide-inner">
                            <img
                              decoding="async"
                              className="swiper-slide-image"
                              src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/dfgdrgd.jpg"
                              alt="veneer dubai"
                            />
                          </figure>
                        </div>
                      </div>
                      <div
                        className="elementor-swiper-button elementor-swiper-button-prev"
                        role="button"
                        tabindex="0"
                      >
                        <svg
                          aria-hidden="true"
                          className="e-font-icon-svg e-eicon-chevron-left"
                          viewBox="0 0 1000 1000"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path>
                        </svg>
                      </div>
                      <div
                        className="elementor-swiper-button elementor-swiper-button-next"
                        role="button"
                        tabindex="0"
                      >
                        <svg
                          aria-hidden="true"
                          className="e-font-icon-svg e-eicon-chevron-right"
                          viewBox="0 0 1000 1000"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-9efafa9 e-con-full e-flex e-con e-child"
                  data-id="9efafa9"
                  data-element_type="container"
                  id="reviews"
                  data-settings='{"background_background":"classNameic"}'
                >
                  <div
                    className="elementor-element elementor-element-a8553e8 elementor-widget elementor-widget-heading"
                    data-id="a8553e8"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Patient Stories
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-d317c3c elementor-widget elementor-widget-text-editor"
                    data-id="d317c3c"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p>EXPERIENCED FROM POLYCLINIC IN DUBAI</p>
                  </div>
                  <div
                    className="elementor-element elementor-element-141fdcd elementor-testimonial--skin-default elementor-testimonial--layout-image_inline elementor-testimonial--align-center elementor-arrows-yes elementor-pagination-type-bullets elementor-widget elementor-widget-testimonial-carousel"
                    data-id="141fdcd"
                    data-element_type="widget"
                    data-settings='{"show_arrows":"yes","pagination":"bullets","speed":500,"autoplay":"yes","autoplay_speed":5000,"loop":"yes","pause_on_hover":"yes","pause_on_interaction":"yes","space_between":{"unit":"px","size":10,"sizes":[]},"space_between_tablet":{"unit":"px","size":10,"sizes":[]},"space_between_mobile":{"unit":"px","size":10,"sizes":[]}}'
                    data-widget_type="testimonial-carousel.default"
                  >
                    <div
                      className="elementor-main-swiper swiper"
                      role="region"
                      aria-roledescription="carousel"
                      aria-label="Slides"
                    >
                      <div className="swiper-wrapper">
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                        >
                          <div className="elementor-testimonial">
                            <div className="elementor-testimonial__content">
                              <div className="elementor-testimonial__text">
                                I am so happy with my new veneers from Elite
                                Body Home! The dentist was very kind, and the
                                whole team was very professional. My teeth look
                                natural, and I can't stop smiling!
                              </div>
                            </div>
                            <div className="elementor-testimonial__footer">
                              <cite className="elementor-testimonial__cite">
                                <span className="elementor-testimonial__name">
                                  Pamila Thakur
                                </span>
                              </cite>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                        >
                          <div className="elementor-testimonial">
                            <div className="elementor-testimonial__content">
                              <div className="elementor-testimonial__text">
                                The team at Elite Body Home is fantastic! I love
                                how my veneers turned out. The whole process was
                                smooth, and they made sure I was comfortable
                                throughout. So glad I chose them!
                              </div>
                            </div>
                            <div className="elementor-testimonial__footer">
                              <cite className="elementor-testimonial__cite">
                                <span className="elementor-testimonial__name">
                                  Jose Santos
                                </span>
                              </cite>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          role="group"
                          aria-roledescription="slide"
                        >
                          <div className="elementor-testimonial">
                            <div className="elementor-testimonial__content">
                              <div className="elementor-testimonial__text">
                                The dentist was super friendly and explained
                                everything clearly. My smile looks amazing now.
                                Highly recommend their services!
                              </div>
                            </div>
                            <div className="elementor-testimonial__footer">
                              <cite className="elementor-testimonial__cite">
                                <span className="elementor-testimonial__name">
                                  Joshope
                                </span>
                              </cite>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-swiper-button elementor-swiper-button-prev"
                        role="button"
                        tabindex="0"
                        aria-label="Previous"
                      >
                        <svg
                          aria-hidden="true"
                          className="e-font-icon-svg e-eicon-chevron-left"
                          viewBox="0 0 1000 1000"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path>
                        </svg>
                      </div>
                      <div
                        className="elementor-swiper-button elementor-swiper-button-next"
                        role="button"
                        tabindex="0"
                        aria-label="Next"
                      >
                        <svg
                          aria-hidden="true"
                          className="e-font-icon-svg e-eicon-chevron-right"
                          viewBox="0 0 1000 1000"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path>
                        </svg>
                      </div>
                      <div className="swiper-pagination"></div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-8a2ce29 elementor-align-center elementor-widget elementor-widget-button"
                    data-id="8a2ce29"
                    data-element_type="widget"
                    data-widget_type="button.default"
                  >
                    <a
                      className="elementor-button elementor-button-link elementor-size-sm"
                      href="https://business.google.com/v/elite-body-home-slimming-therapy-center-llc/012672062159303961869/1c38/_/rev/?gclid=%7Bgclid%7D"
                      target="_blank"
                      rel="noopener"
                    >
                      <span className="elementor-button-content-wrapper">
                        <span className="elementor-button-text">
                          Read More Reviews
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-d7c8571 e-con-full e-flex e-con e-child"
                  data-id="d7c8571"
                  data-element_type="container"
                  id="myths"
                >
                  <div
                    className="elementor-element elementor-element-3fe0677 elementor-widget elementor-widget-heading"
                    data-id="3fe0677"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Myths vs. Facts About Dental Veneers
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-0db959e elementor-widget elementor-widget-text-editor"
                    data-id="0db959e"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <table>
                      <thead>
                        <tr>
                          <td>
                            <p style={{ textAlign: "center" }}>
                              <strong>Myth</strong>
                            </p>
                          </td>
                          <td>
                            <p style={{ textAlign: "center" }}>
                              <strong>Fact</strong>
                            </p>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p>Veneers are only for celebrities.</p>
                          </td>
                          <td>
                            <p>
                              Veneers are affordable and customizable for
                              everyone, offering a quick way to achieve a
                              flawless smile.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>Veneers damage natural teeth.</p>
                          </td>
                          <td>
                            <p>
                              Veneers require minimal enamel removal and
                              preserve the integrity of your natural teeth.
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="elementor-element elementor-element-f0e0a79 elementor-widget elementor-widget-text-editor"
                    data-id="f0e0a79"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p>
                      <em>
                        For a detailed comparison between a Hollywood Smile and
                        veneers, read our comprehensive guide:
                        <a
                          href="https://elitebodyhome.com/blog/hollywood-smile-vs-veneers/"
                          target="_blank"
                          rel="noopener"
                        >
                          Hollywood Smile vs. Veneers
                        </a>
                        .
                      </em>
                    </p>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-a653e54 e-con-full e-flex e-con e-child"
                  data-id="a653e54"
                  data-element_type="container"
                  id="whychoose"
                >
                  <div
                    className="elementor-element elementor-element-385f797 elementor-widget elementor-widget-heading"
                    data-id="385f797"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Why Choose Elite Body Home for Your Dental Veneers Dubai?
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-efa644d elementor-widget elementor-widget-text-editor"
                    data-id="efa644d"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <p>
                      <a
                        href="https://elitebodyhome.com/"
                        target="_blank"
                        rel="noopener"
                      >
                        Elite Body Home Polyclinic
                      </a>
                      is one of the best places for veneers in Dubai, we combine
                      advanced dental technology with personalized care to
                      deliver exceptional results. Our team of highly skilled
                      cosmetic dentistry Dubai is committed to ensuring your
                      veneers look natural and complement your overall
                      appearance. We use top-quality materials to create
                      durable, stain-resistant veneers that are customized to
                      your unique needs. With our patient-centered approach and
                      state-of-the-art techniques, we guarantee a comfortable,
                      efficient, and satisfying experience, helping you achieve
                      the perfect smile you’ve always wanted. Choose us for
                      unparalleled expertise and long-lasting results.
                    </p>
                  </div>
                  <div
                    className="elementor-element elementor-element-dc4a254 e-con-full e-flex elementor-invisible e-con e-child"
                    data-id="dc4a254"
                    data-element_type="container"
                    data-settings='{"animation":"fadeInUp"}'
                  >
                    <div
                      className="elementor-element elementor-element-1e3aa1f elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="1e3aa1f"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <span className="elementor-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              id="Layer_1"
                              data-name="Layer 1"
                              viewBox="0 0 500 500"
                            >
                              <path d="M106.67,440.88c-5.07-13.39-10.09-26.64-15.2-40.13,13.39-5.07,26.69-10.11,40.1-15.19,.28,.65,.52,1.15,.72,1.67,4.17,10.99,8.34,21.98,12.46,32.99,.45,1.2,1.13,1.96,2.26,2.54,22.44,11.63,46.24,18.4,71.45,20.34,68.59,5.27,136.05-29.89,170.94-89.17,.23-.39,.44-.78,.66-1.18-16.06-11.44-22.5-26.54-14.97-45.2,6.68-16.55,20.38-23.11,38.2-22,5.31-42.36-2.69-81.99-24.35-118.99,2.13-1.33,4.19-2.61,6.44-4,1.1,1.92,2.17,3.7,3.18,5.53,10.34,18.65,17.43,38.45,21.1,59.46,3.35,19.17,3.8,38.41,1.27,57.71-.22,1.68,.04,2.54,1.77,3.31,14.65,6.56,22.84,21.3,20.96,37.43-1.75,15.07-13.59,27.61-28.93,30.58-5.33,1.03-10.64,.82-15.88-.58-1.22-.33-1.79-.08-2.42,.99-14,23.74-32.23,43.62-54.74,59.51-22.71,16.03-47.74,26.7-75.11,31.57-43.63,7.76-85.15,1.36-124.41-19.3-1.06-.56-1.9-.59-3.01-.17-10.34,3.96-20.71,7.86-31.07,11.78-.37,.14-.75,.26-1.4,.49Z"></path>
                              <path d="M297.29,336.54H166.57c0-.71,0-1.32,0-1.93,0-15.46-.12-30.91,.04-46.37,.12-11.74,4.86-21.19,14.79-27.82,4.11-2.75,8.83-3.47,13.53-4.27,3.08-.52,6.17-.99,9.25-1.51,2.72-.46,3.66,.1,4.55,2.77,4.25,12.65,8.49,25.3,12.74,37.95,2.24,6.68,4.48,13.35,6.73,20.03,.11,.32,.21,.65,.33,.97,.58,1.58,1.62,2.65,3.36,2.68,1.82,.02,2.95-1.03,3.52-2.7,1.55-4.57,3.08-9.15,4.62-13.73,5.02-14.97,10.04-29.93,15.08-44.9,1.07-3.17,1.73-3.58,5.01-3.03,4.54,.75,9.07,1.55,13.6,2.33,10.39,1.78,16.96,8.14,20.94,17.55,1.79,4.23,2.69,8.69,2.7,13.28,.04,15.8,.01,31.59,.01,47.39,0,.39-.05,.78-.09,1.31Z"></path>
                              <path d="M115.32,299.86c14.05,37.83,39.33,64.57,77.58,77.05,48.42,15.8,90.92,3.68,127.97-30.82,1.56,1.44,3.37,3.11,5.45,5.02-3.78,3.43-7.3,6.89-11.09,10.02-20.17,16.66-43.3,26.45-69.3,29.31-60.16,6.63-117.48-29.7-137.2-86.98-.62-1.79-1.35-2.38-3.3-2.37-19.15,.13-35.1-15.1-35.88-34.11-.8-19.61,13.67-36.04,33.11-37.45,2.02-.15,2.83-.78,3.37-2.76,12.23-45.14,47.06-80.28,92.26-92.01,39.24-10.19,75.79-3.4,109.25,19.6,.37,.25,.69,.56,1.17,.94-1.51,1.99-2.97,3.91-4.3,5.66-43.94-28.33-88.96-31.7-134.81-5.8-32.12,18.14-50.52,49.15-56.41,74.81,16.33,4.98,26.3,15.47,27.96,32.84,.8,8.38-1.5,16.11-6.33,23.03-4.79,6.84-11.3,11.38-19.51,14.05Z"></path>
                              <path d="M136.52,104.57c-33.34,20.91-57.8,49.41-73.47,85.66-1.2-.47-2.35-.9-3.5-1.36-1.1-.44-2.2-.9-3.47-1.42,.24-.65,.43-1.22,.67-1.77,16-36.71,40.99-65.69,74.89-86.98,1.17-.73,1.48-1.31,1.03-2.68-6.07-18.48,3.34-38.21,21.38-44.98,18.17-6.81,38.17,1.84,45.8,19.87,.6,1.42,1.19,1.75,2.73,1.52,30-4.54,59.48-2.32,88.38,7.03,14.77,4.78,28.73,11.32,41.88,19.58,1.17,.73,2.17,.88,3.48,.54,11.16-2.9,22.33-5.74,33.5-8.59,.43-.11,.86-.18,1.44-.29,3.53,13.83,7.05,27.57,10.61,41.53-13.89,3.55-27.66,7.07-41.59,10.63-.65-2.51-1.28-4.85-1.88-7.21-2.32-9.08-4.61-18.17-6.99-27.23-.22-.83-.84-1.77-1.55-2.22-25.34-16.04-52.96-25.31-82.85-27.81-14.28-1.19-28.5-.67-42.66,1.44-.6,.09-1.2,.23-1.79,.34,.75,17.92-6.24,31.48-23.16,37.87-17.2,6.49-31.57,.86-42.89-13.49Z"></path>
                              <path d="M231.89,172.29c5.38,.17,10.57,.92,15.4,3.37,8.31,4.23,12.71,12.66,11.41,21.88-.37,2.64-.85,5.27-1.16,7.92-.08,.67,.3,1.41,.55,2.09,.46,1.25,1.38,2.48,1.41,3.73,.03,2.12-.21,4.34-.87,6.34-.41,1.25-1.64,2.42-2.79,3.19-1.27,.85-2.12,1.72-2.47,3.23-2.16,9.32-10.56,16.75-20.08,17.56-6.56,.56-11.94-2.19-16.5-6.7-3.14-3.1-5.4-6.73-6.27-11.11-.27-1.35-.96-2.28-2.21-2.8-1.83-.77-2.87-2.21-3.29-4.07-.31-1.38-.67-2.79-.66-4.19,0-1.33,.03-3.04,.8-3.9,1.74-1.93,1.14-3.85,.9-5.95-.42-3.71-1.24-7.51-.82-11.15,1.09-9.52,8.1-16.36,18.23-18.39,2.77-.56,5.62-.7,8.43-1.04Z"></path>
                              <path d="M232.05,252.49c1.31,0,2.61-.02,3.92,0,4.59,.06,7.22,4.49,5.02,8.53-1.09,1.99-2.45,3.84-3.49,5.85-.51,.99-.85,2.24-.75,3.32,.52,5.71,1.21,11.41,1.81,17.11,.07,.66,.07,1.38-.14,2-1.44,4.31-2.89,8.62-4.48,12.87-.38,1.01-1.34,1.81-2.03,2.7-.64-.89-1.52-1.68-1.89-2.67-1.57-4.2-3-8.45-4.43-12.71-.22-.67-.25-1.46-.18-2.17,.6-5.82,1.28-11.63,1.83-17.45,.08-.88-.17-1.9-.59-2.68-1.04-1.95-2.27-3.8-3.42-5.69-1.26-2.06-1.38-4.19-.23-6.31,1.13-2.09,3.03-2.77,5.3-2.7,1.25,.03,2.5,0,3.75,0Z"></path>
                            </svg>
                          </span>
                        </div>

                        <div className="elementor-icon-box-content">
                          <p className="elementor-icon-box-description">
                            Over 25 years Of Experience
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-0eb1179 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="0eb1179"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <span className="elementor-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              id="Layer_1"
                              data-name="Layer 1"
                              viewBox="0 0 500 500"
                            >
                              <path d="M351.28,292.31c5.45,13.23,11.16,26.16,16.1,39.38,5.96,15.94,10.42,32.36,10.52,49.51,.04,6.28-.84,12.82-2.7,18.81-3.86,12.37-14.57,16.96-26.64,15.64-16.07-1.76-29.2-10.24-42.45-18.44-2.17-1.35-4.32-2.74-6.41-4.21-2.97-2.07-6.29-2.61-9.51-1.3-12.27,5.01-26.52-7.67-25.13-20.21,.82-7.43,.25-7.65-4.52-10.31-4.85,6.64-9.62,13.38-14.61,19.96-12.9,17.01-26.87,33.02-44.75,45.06-7.71,5.19-16.04,8.95-25.71,8.49-8.52-.4-14.24-4.95-18.3-12.07-5.83-10.2-7.14-21.51-7.6-32.89-.99-24.23,3.35-47.84,9.23-71.58-7.21-.55-14.24-.89-21.22-1.65-22.12-2.42-44.16-5.49-64.4-15.45-5.53-2.72-10.71-6.58-15.25-10.79-9.78-9.06-9.53-22.04-.26-34.19,7.75-10.17,18.51-16.38,29.17-22.75,3.72-2.23,7.55-4.3,11.42-6.26,2.66-1.35,3.96-3.31,4.23-6.28,.67-7.25,4.42-12.28,11.15-15.21,6.89-3.01,13.4-2.86,19.5,1.81,2.89,2.21,5.65,3.85,9.38,1.54,1.43-.88,3.42-.87,5.81-1.42-.64-1.7-1.09-3.2-1.76-4.59-10.32-21.27-19.04-43.12-23.66-66.4-2.18-10.97-3.23-22.04-.44-33.09,3.87-15.33,15.49-22.39,31.03-19.18,17.94,3.7,33.41,12.56,47.73,23.38,12.76,9.64,24.83,20.18,37.49,30.56,4.11-5.6,8.55-11.76,13.11-17.84,13.21-17.61,27.63-34.06,46.12-46.39,7.61-5.07,15.76-8.9,25.34-8.63,7.83,.22,13.75,3.56,17.95,9.98,4.93,7.54,7.41,16.05,7.85,24.89,.53,10.6,.23,21.26,.03,31.88-.05,2.76,.72,4.36,3,5.98,6.73,4.79,9.13,11.82,7.66,19.6-1.42,7.52-6.28,12.85-13.94,14.77-5.09,1.28-3.47,5.8-5.7,9.04,8.21,.64,15.73,1.02,23.19,1.85,23.65,2.64,47.23,5.8,68.22,18.24,4.55,2.7,9.03,6.1,12.38,10.14,7.29,8.81,7.06,18.61,.41,28.67-7.63,11.53-18.55,19.26-30.14,26.25-17.3,10.44-36.27,16.82-55.35,22.98-2.54,.82-5.02,1.81-7.53,2.73-.09,.03-.13,.2-.02,.02ZM129.13,110.93c.39,3.6,.68,6.79,1.09,9.95,.23,1.76,.6,3.52,1.05,5.25,6.57,25.58,17.32,49.49,29.34,72.88,.94,1.84,2.05,2.82,4.57,2.21,12.75-3.08,25.58-5.81,38.32-8.94,1.72-.42,3.58-2.09,4.51-3.68,7.03-12.01,13.82-24.15,20.75-36.22,1.1-1.92,1.3-3.39-.54-5.04-14-12.6-27.61-25.66-42.02-37.77-10.58-8.89-22.52-15.96-36.27-19.2-10.15-2.4-17.18,1.7-19.47,11.48-.72,3.09-.93,6.29-1.33,9.08Zm215.83,83.85c-1.2,0-2.76,.17-4.27-.04-3.3-.46-4.9,1.08-5.84,4.09-4.13,13.11-8.45,26.16-12.48,39.3-.54,1.77-.49,4.31,.4,5.85,6.44,11.17,13.17,22.17,19.8,33.23,1.15,1.92,2.54,2.47,4.8,1.65,5.51-1.97,11.11-3.68,16.67-5.48,16.85-5.45,33.8-10.71,49.33-19.44,9.13-5.13,18.32-10.29,24.85-18.95,5.41-7.18,5.43-14.49-1.49-19.95-5-3.95-10.9-7.26-16.93-9.31-24.1-8.23-49.26-9.98-74.84-10.97Zm-184.82,199.85c.23,3.17,.51,8.16,1.01,13.12,.19,1.88,.85,3.73,1.42,5.55,3.99,12.84,13.54,16.7,25.35,10.19,8.39-4.62,15.41-10.97,21.95-17.88,14.92-15.78,27.2-33.55,39.17-51.58,1.99-3,2.01-4.83-.5-7.51-8.42-8.98-16.63-18.15-24.75-27.4-2.06-2.34-4.2-3.47-7.29-3.33-10.51,.5-21.02,.84-31.53,1.34-3.92,.19-8.89-.66-11.43,1.39-2.52,2.03-2.71,7.07-3.73,10.85-5.58,20.78-9.13,41.87-9.67,65.25Zm-9.57-91.81c3.48,0,6.56-.07,9.63,.03,1.95,.06,2.87-.57,3.5-2.58,4.25-13.6,8.73-27.12,12.95-40.73,.5-1.63,.4-3.96-.42-5.41-6.41-11.33-13.05-22.53-19.69-33.72-.6-1-1.94-2.49-2.65-2.34-3.72,.74-7.6,1.46-10.9,3.18-1.53,.79-1.9,3.83-2.75,5.87-.44,1.05-.66,2.19-1.16,3.19-5.48,10.98-20.08,13.7-29.77,5.74-1.12-.92-3.43-1.7-4.52-1.17-9.84,4.8-19.84,9.4-29.14,15.12-5.53,3.4-10.53,8.19-14.63,13.27-5.97,7.41-4.53,16.05,3.37,21.28,5.46,3.62,11.49,6.78,17.71,8.75,22.37,7.09,45.6,8.58,68.48,9.52Zm203.01,104.83c1.41-.21,2.93-.35,4.42-.67,8.08-1.76,11.27-10.57,11.55-18.37,.22-6.03-.96-12.24-2.34-18.17-5.9-25.38-16.78-48.81-29.07-71.62-.65-1.21-3.24-2.32-4.62-2.03-12.34,2.58-24.6,5.5-36.89,8.29-3.03,.69-5.11,2.23-6.67,5.1-6.1,11.2-12.49,22.24-18.71,33.38-.97,1.74-3.28,3.65-.75,5.68,2.62,2.11,3.85,6.56,8.99,4.54,14.54-5.7,28.81,8.65,24.46,22.69-.77,2.5-.04,4.53,2.1,6.04,7.93,5.6,15.67,11.51,23.86,16.7,7.12,4.51,14.98,7.54,23.66,8.44Zm-14.73-302.63c-.64-5.73-.82-11.8-2.06-17.65-3.09-14.65-12.28-22.18-27.61-12.33-6.93,4.46-13.24,10.1-19.16,15.89-16.12,15.77-28.72,34.32-40.96,53.13-1.61,2.47-1.74,4.11,.26,6.32,8.59,9.53,16.93,19.28,25.66,28.66,1.5,1.61,4.49,2.58,6.79,2.57,11.53-.03,23.06-.65,34.59-.75,8.61-.07,8.53,.11,11.25-8,.89-2.65,.41-4.45-1.61-6.43-10.67-10.49-7.11-26.51,6.84-31.98,1.45-.57,3.15-2.47,3.34-3.93,1.11-8.37,1.8-16.79,2.66-25.51Zm-71.6,92.85c-.26,0-.52-.03-.77,0-15.58,2.07-31.17,4.06-46.71,6.36-1.61,.24-3.57,2.1-4.3,3.7-6.4,14.03-12.52,28.18-18.81,42.25-1.21,2.71-1.11,4.88,.73,7.39,10.09,13.82,20.01,27.77,30.05,41.63,.41,.56,1.51,1,2.22,.91,16.63-1.97,33.25-4.02,49.87-6.05,2.62-.32,4.23-1.57,5.34-4.15,5.89-13.69,11.87-27.35,18.09-40.9,1.88-4.1,1.59-7.37-1.04-10.95-8.7-11.84-17.2-23.83-25.84-35.72-2.13-2.93-5.01-4.73-8.84-4.47Zm-57.3,104.07c-7.58-10.43-14.72-20.24-22.13-30.44-3.64,11.01-7.05,21.35-10.58,32.03,10.9-.53,21.37-1.04,32.71-1.59Zm79.28-105.71c7.64,10.29,14.72,19.82,22.26,29.97,3.64-10.87,7.02-20.95,10.55-31.47-10.89,.5-21.36,.98-32.8,1.5Zm-28.99-12.58c-6.97-8.08-13.55-15.7-20.35-23.57-5.39,9.7-10.38,18.71-15.68,28.25,12.11-1.57,23.6-3.06,36.03-4.68Zm-1.25,153.9c5.27-9.46,10.32-18.51,15.58-27.96-12.02,1.55-23.58,3.05-35.79,4.63,7.03,8.12,13.47,15.55,20.21,23.33Zm-89.92-123.16c5.29,8.69,10.12,16.63,15.43,25.36,4.73-11.02,9.02-21.02,13.66-31.85-9.92,2.21-19.02,4.24-29.09,6.49Zm160.98,69.18c-5.2-8.61-10.1-16.73-15.37-25.45-4.68,10.77-9.07,20.87-13.83,31.81,10.08-2.2,19.42-4.23,29.2-6.36Z"></path>
                              <path d="M249.67,281.08c-18.53,0-32.6-14-32.25-32.55,.35-18.58,15.97-31.55,32-31.54,15.92,.02,32.19,12.18,32.4,31.95,.21,20.25-15.86,32.8-32.15,32.14Z"></path>
                            </svg>
                          </span>
                        </div>

                        <div className="elementor-icon-box-content">
                          <p className="elementor-icon-box-description">
                            State of the Art Technology
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-8d67233 elementor-view-default elementor-position-top elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                      data-id="8d67233"
                      data-element_type="widget"
                      data-widget_type="icon-box.default"
                    >
                      <div className="elementor-icon-box-wrapper">
                        <div className="elementor-icon-box-icon">
                          <span className="elementor-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              id="Layer_1"
                              data-name="Layer 1"
                              viewBox="0 0 500 500"
                            >
                              <path d="M448.01,290.12c-.75,3.4-1.59,6.78-2.52,10.14-2.14,7.82-4.73,15.52-7.77,23.08-2.26,5.66-4.78,11.23-7.54,16.7-8.66,17.16-19.76,33.31-33.25,47.86-2.38,2.57-4.83,5.08-7.36,7.54-.39,.39-.77,.77-1.16,1.16-84.36,83.4-227.29,81.53-305.6-8.93,41.1,36.78,95.26,57.64,150.07,56.48,47.98-.65,93.74-18.08,129.93-47.55,3.43-2.78,6.78-5.68,10.03-8.69,21.05-19.45,38.25-43.27,49.87-70.35,.67-1.52,1.33-3.05,1.96-4.58,1.38-3.32,2.65-6.66,3.83-10.03,1.52-4.3,2.89-8.65,4.1-13.03,.84-3.02,1.6-6.05,2.3-9.1,15.26-66.93-3.41-140.33-49.57-192.21,58.19,51.63,78.65,130.03,62.68,201.51Z"></path>
                              <path d="M434.9,280.82c-2.54-1.31-5.22-2.44-8.01-3.37-18.1-6.06-36.88-10.18-55.52-14.43-3.31-.75-8.45,1.06-11.04,3.49-12.93,12.15-25.25,24.95-37.88,37.42-8.94,8.84-15.06,8.79-24.13-.19-12.61-12.49-24.94-25.26-37.83-37.46-2.42-2.29-7.21-4.02-10.32-3.33-17.56,3.87-35.19,7.79-52.34,13.14-27.43,8.57-43.48,31.22-43.88,60-.16,11.44-.08,22.89-.07,34.34,.01,18.04,8.18,26.17,26.21,26.17h208.32c.39-.39,.77-.77,1.16-1.16,2.53-2.46,4.98-4.97,7.36-7.54-8.03,0-16.06,.01-24.09,.01-64.97,.03-129.95,.01-194.92-.06-10.7-.01-15.02-4.6-15.16-15.35-.17-12.88-.3-25.76,.01-38.63,.42-17.44,7.85-31.69,22.04-41.63,15.55-10.89,34.21-13.36,53.6-18.63,0,15.43,.21,28.85-.22,42.25-.07,2-2.78,4.5-4.87,5.73-10.37,6.06-14.72,15.18-11.84,25.83,2.57,9.5,11,16.11,20.77,16.26,10.28,.17,19.63-7.08,22.02-17.06,2.35-9.82-2.49-19.38-12.18-25.08-2.07-1.22-4.67-3.79-4.73-5.8-.41-14.27-.21-28.55-.21-45.51,4.57,2.29,8.2,3.18,10.53,5.43,11.75,11.3,23.12,23,34.7,34.49,12.38,12.27,23.89,12.17,36.35-.23,11.78-11.7,23.75-23.22,35.24-35.19,6.47-6.75,12.98-1.6,19.16-.46,1.82,.34,2.63,6.15,3.8,9.19-7.55,2.76-13.75,4.25-19.18,7.17-15.77,8.49-24.83,21.89-25.63,39.89-.65,14.57-.37,29.19-.04,43.77,.06,2.47,2.32,6.77,3.92,6.95,4.6,.52,9.38-.65,14.09-1.16-.65-2.12-.69-4.96-2.12-6.17-1.48-1.26-4.3-.94-7.04-1.39,0-15.09-1.15-30.31,.28-45.28,1.94-20.34,20.83-34.5,42.02-33.43,13.23,.66,24.95,8.23,31.44,19.17,3.18,5.38,5.1,11.58,5.32,18.17,.1,2.96,.16,5.92,.19,8.89,2.76-5.47,5.28-11.04,7.54-16.7-1.55-7.8-4.66-14.67-9.22-20.39-6.43-8.12-15.77-13.94-27.61-16.9-5.65-1.41-7.25-3.37-4.56-9.64,10.81,3.74,22.01,6.49,32.18,11.36,1.42,.68,2.78,1.39,4.09,2.15,5.07,2.91,9.36,6.37,12.89,10.34,.93-3.36,1.77-6.74,2.52-10.14-3.87-3.67-8.26-6.81-13.11-9.3Zm-178.88,61.2c-.17,7.01-6.15,12.83-13.32,12.94-6.97,.11-13.21-5.89-13.38-12.87-.18-7.37,6.04-13.77,13.38-13.76,7.48,0,13.49,6.18,13.32,13.69Z"></path>
                              <path d="M245.55,219.9c-5.14,25.08-9.71,27.9-36.11,23.26,4.24-11.34,8.5-22.95,12.96-34.48,.56-1.43,2.08-2.61,3.38-3.63q6.59-5.16,2.68-13.6c-1.67,1.57-3.04,3.93-4.93,4.47-8.46,2.42-9.42,8.97-10.89,16.27-2.42,12.04-8.46,22.4-18.27,30.22-14.76,11.76-32.76,11.45-47.16-.64-9.13-7.66-14.8-17.55-17.31-28.93-1.63-7.38-2.28-14.56-11.19-17.06-1.58-.44-3.18-2.69-3.76-4.44-2.99-9-5.65-18.12-8.6-27.77,40.62,10.96,72.8,.16,97.76-31.12,6.08,8.37,12.05,16.59,18.01,24.8,1.44-.71,2.87-1.42,4.3-2.13-.99-3.32-1.68-6.78-3.04-9.95-3.9-9.05-8-18.03-12.2-26.94-1.1-2.33-2.88-4.33-4.35-6.47-1.87,1.83-4.49,3.32-5.5,5.54-15.25,33.79-56.44,50.87-90.8,37.68-3.14-1.2-9.08-2.27-9.88-1-2.03,3.24-3.13,8.09-2.39,11.86,1.76,8.94,4.35,17.79,7.53,26.33,1.51,4.08,4.44,8.43,7.98,10.74,4.55,2.97,5.95,6.61,7.6,11.36,3.46,10.03,8.21,19.61,12.56,29.64-6.74,0-13.59-.02-20.45,.01-8.42,.04-13.01-3.63-14.41-12.4-3.41-21.44-7.73-42.73-11.22-64.15-5.39-33.03,5.59-60,32.04-82.81,2.3,5.49,3.47,10.05,5.99,13.67,1.71,2.47,5.28,5.12,8.06,5.16,26.84,.37,53.69,.34,80.53,0,2.66-.03,6.14-2.14,7.73-4.37,2.54-3.55,2.36-9.08,8.65-9.65,.8-.07,1.54-4.18,1.77-6.48,.27-2.7-.86-5.78,.03-8.16,5.67-15.17-1.51-30.38-17.34-31.18-27.35-1.37-54.85-1.15-82.23-.06-13.2,.52-22.67,14.06-18.98,25.5,2.19,6.77-.39,9.48-4.68,13.4-23.98,21.94-35.22,49.08-30.64,81.56,3.43,24.31,8.01,48.46,12.37,72.63,1.72,9.52,9.42,15.52,19.7,15.9,7.15,.27,14.37-.47,21.46,.21,7.79,.76,15.68,1.91,23.12,4.2,10.24,3.16,20.7,4.85,30.15,.06,9.06-4.59,18.12-4.32,27.47-4.39,5.73-.05,11.47,.1,17.19-.04,8.68-.21,15.39-3.65,19.35-11.8,4.01-8.27-1.78-14.1-4.04-20.83ZM135.58,51.8c12.74-1.45,25.6-1.97,38.32-2.88,12.68,.89,25.24,1.39,37.71,2.74,12.81,1.39,17.21,9.37,12.26,20.99-3.01,7.07-4.33,16.89-9.71,20.34-5.22,3.36-14.67-.18-22.25-.06-17.4,.28-34.79,.77-52.16,1.58-4.37,.21-6.79-.54-8.27-4.99-1.98-5.93-4.78-11.58-7.23-17.36-4.47-10.57-.08-19.06,11.33-20.36Z"></path>
                              <path d="M387.66,158.49c-5.51-4.79-4.39-10.76-4.16-16.59,.3-7.71,.98-15.41,1.49-23.11,.65-.18,1.29-.35,1.93-.53-2.58-9.78-2.39-21.94-8.34-28.82-10.71-12.37-23.69-24.55-38.28-31.37-20.03-9.38-42.36-8.36-63.47,.37-30.67,12.69-46.43,39.14-43.2,72,1.02,10.43,5.11,20.92-1.5,31.28-1.46,2.29-.17,6.73,.64,9.99,1.91,7.76,3.85,15.56,6.64,23.02,1.74,4.68,4.07,10.18,7.87,12.81,5.58,3.87,7.17,8.88,8.99,14.62,7.65,24.19,27.95,40.33,52.16,41.89,21.25,1.37,43.09-12.45,53.16-34.09,4.21-9.07,5.32-19.86,15.38-25.46,1.3-.72,2.17-2.73,2.65-4.32,3.39-11.19,6.85-22.37,9.75-33.7,.62-2.44-.03-6.53-1.71-7.99Zm-145.9-43.33c3.82-33.31,36.13-56.92,72.01-54.06,16.74,1.34,32.39,4.45,42.25,20.14,1.14,1.83,3.24,3.47,5.26,4.27,12.19,4.81,14.98,15.09,14.95,26.41-.03,11.96-1.14,23.91-1.84,36.95-8.15-5.65-9.49-13.65-11.39-21.49-.73-3.04-2.1-7.86-3.95-8.26-2.83-.61-6.79,1.29-9.48,3.22-25.71,18.4-53.62,23.25-83.68,13.44-11.35-3.7-11.11-4.31-17.12,6.02-.79,1.36-2.03,2.46-4.67,5.59-1.02-12.43-3.45-22.53-2.34-32.23Zm137.82,54.5c-2.09,8.58-4.47,17.12-7.24,25.5-.84,2.55-2.84,5.8-5.08,6.61-7.53,2.7-8.42,8.84-10.11,15.31-5.98,22.92-26.1,38.77-47.83,38.26-21.13-.48-40.49-16.92-45.88-39.68-1.38-5.82-2.61-10.51-8.8-13.31-2.89-1.31-4.74-5.44-6.45-8.63-1.31-2.46-1.47-5.5-2.47-8.16-4.7-12.6-8.46-24.79,6.56-33.79,2.66-1.59,3.94-5.47,6.23-8.83,28.2,10.41,61.93,9.26,95.99-12.32,3.05,14.51,10.68,25.66,23.28,33.34,1.33,.81,2.22,3.99,1.8,5.7Z"></path>
                              <path d="M151.14,304.62c-9.61-9.26-19.41-18.38-28.78-27.91-3.73-3.79-7.27-4.78-12.15-2.86-9.82,3.88-19.96,7.03-29.6,11.3-16.19,7.17-24.26,20.37-25.23,37.74-.56,9.98-.28,20.02-.14,30.02,.13,8.88,2.92,11.47,12.11,11.49,24.91,.07,49.81,.06,74.72,.1,.56,0,1.12,.21,2.51,.49,.2,2.14,.42,4.51,.64,6.88-1.36,.53-2.13,1.08-2.89,1.08-26.34,.07-52.68,.19-79.01,.04-8.67-.05-16.01-5.85-16.25-14.58-.44-15.65-.75-31.55,1.49-46.97,2.26-15.5,12.44-27.04,26.87-33.42,12.24-5.41,25.01-9.78,37.82-13.69,3.24-.99,8.57,.37,11.2,2.65,9.49,8.24,18.04,17.55,27.33,26.03,4.56,4.16,4.31,7.39-.64,11.6Z"></path>
                              <path d="M211.64,51.66c-12.47-1.35-25.03-1.85-37.71-2.74-12.72,.91-25.58,1.43-38.32,2.88-11.41,1.3-15.8,9.79-11.33,20.36,2.45,5.78,5.25,11.43,7.23,17.36,1.48,4.45,3.9,5.2,8.27,4.99,17.37-.81,34.76-1.3,52.16-1.58,7.58-.12,17.03,3.42,22.25,.06,5.38-3.45,6.7-13.27,9.71-20.34,4.95-11.62,.55-19.6-12.26-20.99Z"></path>
                              <path
                                className="cls-1"
                                d="M167.32,63.59c2.98-4.26,5.09-7.27,7.2-10.29,1.93,3.27,3.87,6.54,5.57,9.42,3.31,2.09,6.73,4.25,10.15,6.4-3.24,2.01-6.49,4.01-9.87,6.11-1.97,2.81-4.36,6.22-6.75,9.63-1.74-3.12-3.48-6.24-5.32-9.54-2.96-1.98-6.51-4.37-10.07-6.75,3.41-1.87,6.83-3.74,9.09-4.99Z"
                              ></path>
                            </svg>
                          </span>
                        </div>

                        <div className="elementor-icon-box-content">
                          <p className="elementor-icon-box-description">
                            Experienced Medical Doctors
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-1afdd84 e-con-full e-flex e-con e-child"
                  data-id="1afdd84"
                  data-element_type="container"
                  id="ourteam"
                >
                  <div
                    className="elementor-element elementor-element-7d0d4a4 elementor-widget elementor-widget-heading"
                    data-id="7d0d4a4"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Meet Our Expert: Excellence in Dental Care
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-5797146 e-con-full e-flex e-con e-child"
                    data-id="5797146"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-de7241e e-con-full e-flex e-con e-child"
                      data-id="de7241e"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-3a47756 elementor-widget elementor-widget-image"
                        data-id="3a47756"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="1024"
                          height="1024"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-large.jpg"
                          className="attachment-large size-large wp-image-13080"
                          alt=""
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-large.jpg   1024w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-300x300.jpg  300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-small.jpg    150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-768x768.jpg  768w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-600x600.jpg  600w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5-100x100.jpg  100w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Doctor-of-Elite-Body-Home-Polyclinic-Dubai-5.jpg         1080w
                    "
                          sizes="(max-width: 1024px) 100vw, 1024px"
                        />
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-f228a02 e-con-full e-flex e-con e-child"
                      data-id="f228a02"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-21e277d elementor-widget elementor-widget-heading"
                        data-id="21e277d"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <h2 className="elementor-heading-title elementor-size-default">
                          Dr. Arslan Manzoor
                        </h2>
                      </div>
                      <div
                        className="elementor-element elementor-element-f5d7944 elementor-widget elementor-widget-text-editor"
                        data-id="f5d7944"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <p>
                          <strong>
                            Specialist Dentist &amp; Professor of Oral &amp;
                            Maxillofacial Surgery
                          </strong>
                        </p>
                        <p>
                          Dr. Arslan Manzoor is a renowned Specialist Dentist
                          and Professor in Oral &amp; Maxillofacial Surgery with
                          extensive expertise in advanced dental and facial
                          procedures. With a passion for excellence and a
                          dedication to patient care, he combines clinical
                          precision with academic rigor to deliver outstanding
                          results. Dr. Manzoor is highly respected for his skill
                          in complex surgical cases and commitment to mentoring
                          the next generation of dental professionals.
                        </p>
                      </div>
                      <div
                        className="elementor-element elementor-element-3827b9d elementor-align-center elementor-widget elementor-widget-button"
                        data-id="3827b9d"
                        data-element_type="widget"
                        data-widget_type="button.default"
                      >
                        <a
                          className="elementor-button elementor-button-link elementor-size-sm"
                          href="#consultation"
                        >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">
                              Book Free Consultation Today
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-b862fee e-con-full e-flex e-con e-child"
                    data-id="b862fee"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-f6aed2e e-con-full e-flex e-con e-child"
                      data-id="f6aed2e"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-4889260 elementor-widget elementor-widget-image"
                        data-id="4889260"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          width="1024"
                          height="1024"
                          src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-large.jpg"
                          className="attachment-large size-large wp-image-12545"
                          alt=""
                          srcset="
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-large.jpg   1024w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-300x300.jpg  300w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-small.jpg    150w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-768x768.jpg  768w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-600x600.jpg  600w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9-100x100.jpg  100w,
                      https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Dr.-Faris-Alkhanafseh-Elite-Body-Home-Polyclinic-Dubai-9.jpg         1080w
                    "
                          sizes="(max-width: 1024px) 100vw, 1024px"
                        />
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-7a3e8f8 e-con-full e-flex e-con e-child"
                      data-id="7a3e8f8"
                      data-element_type="container"
                    >
                      <div
                        className="elementor-element elementor-element-0b9e187 elementor-widget elementor-widget-heading"
                        data-id="0b9e187"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <h2 className="elementor-heading-title elementor-size-default">
                          Dr. Faris Alkhanafseh
                        </h2>
                      </div>
                      <div
                        className="elementor-element elementor-element-155e2ac elementor-widget elementor-widget-text-editor"
                        data-id="155e2ac"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <p>
                          <strong>Cosmetic Dentist &amp; Implantologist</strong>
                        </p>
                        <p>
                          Dr. Faris Alkhanafseh is a leading cosmetic dentist
                          and implantologist at Elite Body Home Polyclinic,
                          specializing in smile makeovers, veneers, teeth
                          whitening, and dental implants. With extensive
                          experience in aesthetic and restorative dentistry, he
                          combines advanced techniques with a patient-focused
                          approach to deliver natural, long-lasting results.
                        </p>
                      </div>
                      <div
                        className="elementor-element elementor-element-2883e26 elementor-align-center elementor-widget elementor-widget-button"
                        data-id="2883e26"
                        data-element_type="widget"
                        data-widget_type="button.default"
                      >
                        <a
                          className="elementor-button elementor-button-link elementor-size-sm"
                          href="#consultation"
                        >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-text">
                              Book Free Consultation Today
                            </span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-8736bca e-con-full e-flex e-con e-child"
                  data-id="8736bca"
                  data-element_type="container"
                  id="otherservices"
                >
                  <div
                    className="elementor-element elementor-element-e3267ab elementor-widget elementor-widget-heading"
                    data-id="e3267ab"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <h2 className="elementor-heading-title elementor-size-default">
                      Explore Our Specialized Dental Treatments in Dubai
                    </h2>
                  </div>
                  <div
                    className="elementor-element elementor-element-91eae7e e-con-full e-flex e-con e-child"
                    data-id="91eae7e"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-b453418 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor"
                      data-id="b453418"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <ul>
                        <li>
                          <a
                            href="https://elitebodyhome.com/tooth-filling-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Tooth Filling
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/teeth-whitening-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Teeth Whitening
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/dental-crowns-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Dental Crown
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/denture-teeth-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Denture Teeth
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/hollywood-smile-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Hollywood Smile
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/gum-disease-laser-treatment/"
                            target="_blank"
                            rel="noopener"
                          >
                            Gum Disease Laser Treatment
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="elementor-element elementor-element-bb1e4f3 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-text-editor"
                      data-id="bb1e4f3"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <ul>
                        <li>
                          <a
                            href="https://elitebodyhome.com/orthodontics-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Orthodontic Dubai
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/tooth-extraction-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Tooth Extraction
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/root-canal-treatment-dubai/"
                            target="_blank"
                            rel="noopener"
                          >
                            Root Canal Treatment
                          </a>
                        </li>
                        <li>Wisdom Teeth Removal</li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/gum-disease-laser-treatment/"
                            target="_blank"
                            rel="noopener"
                          >
                            Gum Disease Treatment
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/night-guard/"
                            target="_blank"
                            rel="noopener"
                          >
                            Night Guard
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-9137ba1 e-con-full e-flex e-con e-child"
                  data-id="9137ba1"
                  data-element_type="container"
                  data-settings='{"background_background":"classNameic"}'
                >
                  <div
                    className="elementor-element elementor-element-4771645 e-con-full e-flex e-con e-child"
                    data-id="4771645"
                    data-element_type="container"
                  >
                    <div
                      className="elementor-element elementor-element-dcac728 elementor-widget elementor-widget-heading"
                      data-id="dcac728"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <h2 className="elementor-heading-title elementor-size-default">
                        Book Your Free Consultation Now!
                      </h2>
                    </div>
                    <div
                      className="elementor-element elementor-element-9e625b5 elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                      data-id="9e625b5"
                      data-element_type="widget"
                      data-widget_type="divider.default"
                    >
                      <div className="elementor-divider">
                        <span className="elementor-divider-separator"> </span>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-fc52652 elementor-widget elementor-widget-text-editor"
                      data-id="fc52652"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <p>
                        Achieve the smile of your dreams with the best veneers
                        in Dubai. Contact Elite Body Home Polyclinic today to
                        schedule your consultation. Let us help you transform
                        your smile and boost your confidence.
                      </p>
                    </div>
                    <div
                      className="elementor-element elementor-element-04971ff elementor-align-center elementor-widget elementor-widget-button"
                      data-id="04971ff"
                      data-element_type="widget"
                      data-widget_type="button.default"
                    >
                      <a
                        className="elementor-button elementor-button-link elementor-size-sm"
                        href="#consultation"
                      >
                        <span className="elementor-button-content-wrapper">
                          <Link
                            className="elementor-button-text"
                            to={"/contact"}
                          >
                            Schedule Your Consultation Today
                          </Link>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <FAQAccordion faqData={faqData} />
                <ShareButtons url={serviceUrl} />
              </div>
              <div className="rightColumnStyle">
                <Sideform />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Veneers;
